import { validationHelper } from '../../common/helpers'
import { messages } from '../../common/constants'


export function validate(values) {
    const errors = {};

    if (validationHelper.stringIsNullOrEmpty(values.password)) {
        errors.password = messages.MANDATORY_FIELD;
    }

    if (validationHelper.stringIsNullOrEmpty(values.confirmPassword)) {
        errors.confirmPassword = messages.MANDATORY_FIELD;
    }

    return errors
}


// WEBPACK FOOTER //
// ./src/scenes/ResetPassword/_validate.js